import nc1stScience from "./nc1stScienceQuizContent";
import nc1stSocialStudies from "./nc1stSocialStudiesQuizContent";
import nc1stMath from "./nc1stMathQuizContent";
import nc1stOther from "./nc1stOtherQuizContent";

// 2nd Grade
import nc2ndScience from "./nc2ndScienceQuizContent";
import nc2ndSocialStudies from "./nc2ndSocialStudiesQuizContent";
import nc2ndMath from "./nc2ndMathQuizContent";
import nc2ndOther from "./nc2ndOtherQuizContent";

// 3rd Grade
import nc3rdScience from "./nc3rdScienceQuizContent";
import nc3rdSocialStudies from "./nc3rdSocialStudiesQuizContent";
import nc3rdMath from "./nc3rdMathQuizContent";
import nc3rdOther from "./nc3rdOtherQuizContent";

// 4th Grade
import nc4thScience from "./nc4thScienceQuizContent";
import nc4thSocialStudies from "./nc4thSocialStudiesQuizContent";
import nc4thMath from "./nc4thMathQuizContent";
import nc4thOther from "./nc4thOtherQuizContent";

// 5th Grade
import nc5thScience from "./nc5thScienceQuizContent";
import nc5thSocialStudies from "./nc5thSocialStudiesQuizContent";
import nc5thMath from "./nc5thMathQuizContent";
import nc5thOther from "./nc5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const nctopicsMapBySubject = {
  // 1st Grade
  nc_1st_science: nc1stScience,
  nc_1st_socialstudies: nc1stSocialStudies,
  nc_1st_math: nc1stMath,
  nc_1st_other: nc1stOther,

  // 2nd Grade
  nc_2nd_science: nc2ndScience,
  nc_2nd_socialstudies: nc2ndSocialStudies,
  nc_2nd_math: nc2ndMath,
  nc_2nd_other: nc2ndOther,

  // 3rd Grade
  nc_3rd_science: nc3rdScience,
  nc_3rd_socialstudies: nc3rdSocialStudies,
  nc_3rd_math: nc3rdMath,
  nc_3rd_other: nc3rdOther,

  // 4th Grade
  nc_4th_science: nc4thScience,
  nc_4th_socialstudies: nc4thSocialStudies,
  nc_4th_math: nc4thMath,
  nc_4th_other: nc4thOther,

  // 5th Grade
  nc_5th_science: nc5thScience,
  nc_5th_socialstudies: nc5thSocialStudies,
  nc_5th_math: nc5thMath,
  nc_5th_other: nc5thOther,
  // ...add the rest
};
